/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_13_DInputs */

const en_tut_gl_13_d = /** @type {(inputs: Tut_Gl_13_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A short meeting opened from one office room for the people currently standing in it.`)
};

const id_tut_gl_13_d = /** @type {(inputs: Tut_Gl_13_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapat singkat yang dibuka dari satu ruang kantor untuk orang yang sedang berada di ruang itu.`)
};

/**
* | output |
* | --- |
* | "A short meeting opened from one office room for the people currently standing in it." |
*
* @param {Tut_Gl_13_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_13_d = /** @type {((inputs?: Tut_Gl_13_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_13_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_13_d(inputs)
	return en_tut_gl_13_d(inputs)
});